import { Navigate, Outlet, Route, Routes } from "react-router-dom";

import Layout from "@/components/console/layout/Layout";
import NotFound from "@/pages/common/NotFound";
import BoardDetail from "@/pages/console/board/BoardDetail";
import BoardList from "@/pages/console/board/BoardList";
import BoardWrite from "@/pages/console/board/BoardWrite";
import PopupList from "@/pages/console/design/PopupList";
import Login from "@/pages/console/login/Login";

function ConsoleApp() {
    return (
        <Routes>
            <Route path="login" element={<Login />} />
            <Route path="" element={<Navigate to="login" replace />} />

            <Route
                path=""
                element={
                    <Layout>
                        <Outlet />
                    </Layout>
                }
            >
                {/* 게시판 관리 */}
                <Route path="board" element={<Outlet />}>
                    <Route index element={<Navigate to="/404" replace />} />
                    <Route path=":category" element={<BoardList />} />
                    <Route path=":category/:board_idx" element={<BoardDetail />} />
                    <Route path=":category/:board_idx/edit" element={<BoardWrite />} />
                    <Route path=":category/create" element={<BoardWrite />} />
                </Route>
                {/* 디자인 관리 */}
                <Route path="design/popup" element={<PopupList />} />
            </Route>
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}

export default ConsoleApp;
